/* eslint-disable no-undef */ // Required for GoogleAPI
/* eslint-disable*/
import React, { useEffect, useState } from 'react';

import Layout from 'antd/lib/layout';

import { useMap, Map, Marker } from '@vis.gl/react-google-maps';
import { MultiBuildingModal } from '../MultiBuildingModal';
import { AddBuildingModal } from './components/AddBuildingModal';

import './MapView.less';

import mapStyles from './MapStyles';
import mapMarker from './assets/map-marker.svg';
import mapMarkerRed from './assets/map-marker-red.svg';
import mapMarkerHL from './assets/map-marker-hl.svg';

function getPosition(building) {
  return {
    lat: parseFloat(building.latitude),
    lng: parseFloat(building.longitude)
  }
}

export const BuildingMarkers = ({ buildings, selectedBuildingId, onSelectBuilding }) => {
  return (
    <>
      {buildings?.map(building => (
        <Marker
          key={building.identifier}
          data-testid={building.identifier}
          position={getPosition(building)}
          icon={selectedBuildingId === building.identifier ? mapMarkerHL : building.alert_count ? mapMarkerRed : mapMarker}
          onClick={() => onSelectBuilding(building)}
          zIndex={selectedBuildingId === building.identifier ? 10 : 1}
        >
        </Marker>
      ))}
    </>
  );
};

const MapView = (props) => {
  const {
    theme,
    isAddBuildingModalOpen,
    setIsAddBuildingModalOpen,
    selectedBuildingId,
    selectBuilding,
    selectedBuildingInfo,
    buildings,
  } = props;

  const mapReference = useMap();

  useEffect(() => {
    window.document.title = `Home`;

    sessionStorage.removeItem('selectedBuilding');

  }, [isAddBuildingModalOpen]);

  const closeAddBuildingModal = async () => {
    setIsAddBuildingModalOpen(false);
  };

  useEffect(() => {
    if (!mapReference) return;
    if (selectedBuildingInfo?.latitude) {
      mapReference.setCenter({ lat: parseFloat(selectedBuildingInfo.latitude), lng: parseFloat(selectedBuildingInfo.longitude) + 0.05 })
    }
  }, [selectedBuildingInfo, mapReference])

  useEffect(() => {
    if (!mapReference) return;

    const bounds = new google.maps.LatLngBounds()
    buildings.forEach(b => bounds.extend(getPosition(b)));
    mapReference.fitBounds(bounds);
  }, [buildings, mapReference])

  return (
    <Layout className="mbh-wrapper">
      {isAddBuildingModalOpen && <AddBuildingModal onCancel={closeAddBuildingModal} theme={theme} />}
      <Map style={{ height: '100vh' }} className="main-map"
        data-testid="map"
        styles={mapStyles(theme)}
        defaultZoom={13}
        defaultCenter={{ lat: 43.6464503, lng: -79.4049989 }}
        fullscreenControl={false}
        streetViewControl={false}
        mapTypeControl={false}
        clickableIcons={false}

      >
        <BuildingMarkers buildings={buildings} selectedBuildingId={selectedBuildingId} onSelectBuilding={selectBuilding} />
      </Map>
      {selectedBuildingId && (
        <MultiBuildingModal
          buildingInfo={selectedBuildingInfo}
          buildingId={selectedBuildingId}
          onCancel={() => {
            selectBuilding({});
          }}
          theme={theme}
          buildings={buildings}
        />
      )}
    </Layout>
  );
};

export default MapView;
